<div class="mb-5">
	<h1 class="h3 m-4">{{'fleet_reports.battery_fleet_quick_view' | translate}}</h1>

	<div class="chart-container" *ngIf="dataLoaded">
		<div class="filter-container">
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="batteryTypeSelect">{{'devices.battery_type' | translate}}</label>
				<ng-select
					id="batteryTypeSelect"
					class="select"
					[items]="batteryTypeOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="updateCharts()"
					[(ngModel)]="selectedBatteryType"
				></ng-select>
			</div>
		</div>

		<div class="charts-row" *ngIf="!noData; else noDataToShow">
			<sct-charts
				[type]="'BarChart'"
				[title]="'fleet_reports.soc_quick_view' | translate"
				[columnNames]="columnNames"
				[data]="socChartData"
				[options]="socChartOptions">
			</sct-charts>
			<sct-charts
				[type]="'BarChart'"
				[title]="'fleet_reports.plug_in_quick_view' | translate"
				[columnNames]="columnNames"
				[data]="plugInChartData"
				[options]="plugInChartOptions">
			</sct-charts>
		</div>
	</div>
</div>

<ng-template #noDataToShow>
	<div class="alert alert-info m-4">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
